import { render, staticRenderFns } from "./DfrEntriesList.vue?vue&type=template&id=67f0f87c&scoped=true"
import script from "./DfrEntriesList.vue?vue&type=script&lang=js"
export * from "./DfrEntriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f0f87c",
  null
  
)

export default component.exports